import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenChatPreviewStyles = styled(OnboardingPage)`
  .local-title {
    margin: 0 0 8px;
  }
`;

export const BlurOverlayStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(20, 17, 30, 0.8);
  backdrop-filter: blur(6px);
  z-index: 1;
  pointer-events: none;
`;

export const GlowOverlayStyles = styled.div<{ backgroundSrc: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${({ backgroundSrc }) => backgroundSrc}) no-repeat center
    center / cover;
  z-index: 2;
  pointer-events: none;
`;

export const ChatContainerStyles = styled.div`
  position: fixed;
  bottom: 220px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;
  width: calc(100% - 32px);
  max-width: 508px;
  margin: 16px;
`;

export const AnimatedBottomButtonContainer = styled.div<{ show: boolean }>`
  position: fixed;
  bottom: 34px;
  left: 0;
  right: 0;
  z-index: 10;
  max-width: 540px;
  margin: 0 auto;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) => (show ? 'translateY(0)' : 'translateY(100px)')};
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;

  .onboarding-footer__container {
    width: auto;
    border: 1px solid transparent;
    border-radius: 24px;
    background:
      linear-gradient(#14111e, #14111e) padding-box,
      linear-gradient(
          93.08deg,
          rgba(255, 255, 255, 0.2) 0%,
          rgba(255, 255, 255, 0) 25%,
          rgba(255, 255, 255, 0) 75%,
          rgba(255, 255, 255, 0.2) 100%
        )
        border-box;
  }
`;

export const ChatMessageStyles = styled.div<{ variant: 'sent' | 'received' }>`
  padding: 12px 16px;
  width: max-content;
  max-width: 90%;
  border-radius: 18px 18px 18px 0px;
  border: 1px solid transparent;

  ${({ variant }) =>
    variant === 'sent'
      ? `
        margin-left: auto;
        border-radius: 18px 18px 0px 18px;
        background: rgba(128, 62, 255, 1);
      `
      : `
        margin-right: auto;
        background: 
          linear-gradient(#14111ECC, #14111ECC) padding-box,
          linear-gradient(
            93.08deg, 
            rgba(255, 255, 255, 0.2) 0%, 
            rgba(255, 255, 255, 0) 25%, 
            rgba(255, 255, 255, 0) 75%, 
            rgba(255, 255, 255, 0.2) 100%
          ) border-box;
      `}
`;
